module.exports = __webpack_public_path__ + "8be8bf4ec860fd895cf0975c9b5fd2f8.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1_variable/public/modules/image/sample.png
// module id = 317
// module chunks = 0